import { Component, Input, Output, EventEmitter, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { NetViewTreeNodeDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { SlackSettings } from 'UvExplorerServer.Dtos.TS/Tools';
import { ComponentBase, Changeable } from "common";

@Component({
    selector: 'slack-settings',
	templateUrl: './slack-settings.component.html',
    styleUrls: ['./slack-settings.component.scss']
})

export class SlackSettingsComponent extends ComponentBase implements OnInit, OnChanges, Changeable {

	@Input() public target: NetViewTreeNodeDto;
	public get hasTarget(): boolean {
		return !!this.target;
	}

	public settingsForm: UntypedFormGroup;

	public slackWebhooks: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder) {
		super();

		this.buildForm();
    }

    ngOnInit() {
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.buildForm();
	}

	private buildForm(): void {

		let source: SlackSettings;
		if (this.hasTarget && this.target.HasSlackSettings) {
			source = this.target.SlackSettings;
		}
		else {
			source = new SlackSettings();
		}

		let slackWebhooks = source.Webhooks;

		this.slackWebhooks = new UntypedFormControl(slackWebhooks, Validators.required);

		this.settingsForm = this.fb.group({
			slackWebhooks: this.slackWebhooks,
		});	
	}

	// Changeable

	public get tempChanges(): boolean {
		return this.settingsForm.dirty;
	}

	public get tempChangesValid(): boolean {
		return this.settingsForm.valid;
	}

	public get invalidTempChanges(): string[] {
		return ["Slack Settings"];
	}

	public applyTempChanges(): void {
		let slackSettings = new SlackSettings();
		slackSettings.Webhooks = this.slackWebhooks.value;

		this.target.SlackSettings = slackSettings;
		this.target.HasChanges = true;
		this.buildForm();
	}

	public discardTempChanges(): void {
		this.buildForm();
	}
}
